import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from "vue";
import { appStore, teamStore } from "@/hooks";
import {
  AttributeChip,
  FlexBox,
  PanelCard,
  TextButton,
} from "@/components/common";
import SaveTeamInputs from "./SaveTeamInputs.vue";


/**
 * Displays a team.
 */
const __default__ = {
  name: "OrganizationDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editMode = computed(() => appStore.popups.saveTeam);

const team = computed(() => teamStore.team);

const memberCount = computed(() => team.value.members.length + " Members");
const projectCount = computed(() => team.value.projects.length + " Members");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), {
    title: team.value.name
  }, {
    "title-actions": _withCtx(() => [
      (editMode.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            label: "Cancel",
            icon: "cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).close('saveTeam')))
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!editMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(FlexBox), { "full-width": "" }, {
              default: _withCtx(() => [
                _createVNode(_unref(AttributeChip), { value: memberCount.value }, null, 8, ["value"]),
                _createVNode(_unref(AttributeChip), { value: projectCount.value }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createBlock(SaveTeamInputs, { key: 1 }))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})